// The five onboarding avatars the server derives from the answer to "What best
// describes your work?" (GetCurrentUser.avatar). The server-side registry owns
// the mapping from work to avatar; the client only keys first-run content on
// the name it is handed.
export const AVATAR = {
    DEFAULT: 'default',
    BUYER: 'buyer',
    OWNER: 'owner',
    CONSULTANT: 'consultant',
    DEVELOPER: 'developer',
};
const AVATAR_NAMES = new Set(Object.values(AVATAR));
export const isAvatarName = (raw) => AVATAR_NAMES.has(raw);
// "default" is the server's own lane for every answer outside the four named
// avatars and for accounts still owing the step, so an empty value reads as it.
export const parseAvatar = (raw) => {
    if (raw && isAvatarName(raw))
        return raw;
    return AVATAR.DEFAULT;
};
export const FIRST_ACTION_COPY = {
    consultant: {
        headline: "Start with a client's site",
        line: 'Draw the boundary and LandScope builds the terrain layers you can print, export and share with your client.',
        buttonLabel: 'Create Project',
    },
    developer: {
        headline: 'Run your first parcel',
        line: 'Draw the parcel and read its slope, aspect and drainage before you commit to it.',
        buttonLabel: 'Create Project',
    },
    owner: {
        headline: 'Map your property',
        line: 'Draw your land and see its contours and where the water goes.',
        buttonLabel: 'Create Project',
    },
    buyer: {
        headline: "Check the land you're looking at",
        line: 'Draw the listing and see its slope, drainage and terrain stats before you make an offer.',
        buttonLabel: 'Create Project',
    },
    default: {
        headline: 'Start your own project',
        line: 'Map your area of interest. Your first demonstration project is free for 7 days.',
        buttonLabel: 'Create Project',
    },
};
export const firstActionCopyFor = (avatar) => FIRST_ACTION_COPY[avatar];
